import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  background: (p) => p.palette.primary['50'],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1),
  gap: (p) => p.spacing(0.5),
  width: '100%',
};

export const content: SxStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 9,
  background: (p) => p.palette.common.white,
};

export const text: SxStyle = {
  color: (p) => p.palette.primary['500'],
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  letterSpacing: '-0.2px',
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary['500'],
};
